import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';

const DataListener = ({ onPostDataReset = () => null }) => {
    const applicationDetailPostData = useSelector((state) => state.applicationDetailPostData);

    useEffect(() => {
        if (isEmpty(applicationDetailPostData.postData)) {
            onPostDataReset();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [applicationDetailPostData.postData]);

    return null;
};

export default DataListener;
